
import moment from 'moment'

// 深拷贝，仅适用于 json 数据
const deepClone = function (obj) {
  return JSON.parse(JSON.stringify(obj))
}

// 通过文件后缀，返回文件类型
const getFileType = function (suffixType = '') {
  let lowerType = suffixType.toLowerCase()
  let images = ['bmp', 'jpg', 'jpeg', 'png', 'tiff', 'gif']
  let doc = ['doc', 'docx']
  let excel = ['xls', 'xlsx']
  let ppt = ['ppt', 'pptx']
  let pdf = ['pdf']
  let zip = ['zip', 'rar']
  let video = ['rm', 'rmvb', 'mov', 'dat', 'wmv', 'avi', 'flv', 'mp4']
  let audio = ['mp3', 'awv', 'wma']
  if ($.inArray(lowerType, images) !== -1) {
    return 'image'
  } else if ($.inArray(lowerType, doc) !== -1) {
    return 'doc'
  } else if ($.inArray(lowerType, excel) !== -1) {
    return 'excel'
  } else if ($.inArray(lowerType, ppt) !== -1) {
    return 'ppt'
  } else if ($.inArray(lowerType, pdf) !== -1) {
    return 'pdf'
  } else if ($.inArray(lowerType, zip) !== -1) {
    return 'zip'
  } else if ($.inArray(lowerType, video) !== -1) {
    return 'video'
  } else if ($.inArray(lowerType, audio) !== -1) {
    return 'audio'
  } else {
    return ''
  }
}
// 判断是否为某类型office文档（doc 和 ppt 不用kkfileview预览）
const checkOfficeType = {
  isOffice : (suffixType = '')=> {
    let lowerType = suffixType.toLowerCase()
    let officeExt = ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx']
    if ($.inArray(lowerType, officeExt) !== -1) {
      return true
    }
  },
  isZipOrRar : (suffixType = '')=> {
    let lowerType = suffixType.toLowerCase()
    let officeExt = ['zip','rar']
    if ($.inArray(lowerType, officeExt) !== -1) {
      return true
    }
  },
  isImageList :  (fileDetail)=> {
    let suffixType = fileDetail.suffixType ? fileDetail.suffixType : ''
    let lowerType = suffixType.toLowerCase()
    let officeExt = ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx']
    if ($.inArray(lowerType, officeExt) !== -1 && fileDetail.pics && (fileDetail.pics.length || fileDetail.picsCount)) {
      return true
    } else {
      return false
    }
  },
  isPptImg :  (fileDetail)=> {
    let suffixType = fileDetail.suffixType ? fileDetail.suffixType : ''
    let lowerType = suffixType.toLowerCase()
    let officeExt = ['ppt', 'pptx']
    if ($.inArray(lowerType, officeExt) !== -1 && fileDetail.pics && fileDetail.pics.length) {
      return true
    } else {
      return false
    }
  },
  isPdfImg : (fileDetail)=> {
    let suffixType = fileDetail.suffixType ? fileDetail.suffixType : ''
    let lowerType = suffixType.toLowerCase()
    let officeExt = ['pdf']
    if ($.inArray(lowerType, officeExt) !== -1 && fileDetail.pics && fileDetail.pics.length) {
      return true
    } else {
      return false
    }
  }
}

// 文件下载
// Blob 文件下载
// Blob type 文件类型： https://developer.mozilla.org/zh-CN/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types
const downloadBlobFileByName = function downloadBlobFileByName (response, options = { type: 'application/vnd.ms-excel;charset=UTF-8' }, fileName) {
  // let fileName ='xx.xlsx'
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    // IE 模式
    window.navigator.msSaveOrOpenBlob(new Blob([response.data], options), fileName)
  } else {
    // NOE-IE 模式
    let url = window.URL.createObjectURL(new Blob([response.data], options))

    let link = document.createElement('a')
    link.style.display = 'none'
    link.href = url
    link.setAttribute('download', fileName)
    document.body.appendChild(link)
    link.click()
    link.remove()
    window.URL.revokeObjectURL(url)
  }
}
const downloadFile = function downloadFile (response) {
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    // IE 模式
    window.navigator.msSaveOrOpenBlob(new Blob([response.data]), response.headers.name)
  } else {
    // NOE-IE 模式
    let url = window.URL.createObjectURL(new Blob([response.data]))
    let link = document.createElement('a')
    link.style.display = 'none'
    link.href = url
    link.setAttribute('download', decodeURI(response.headers.name))
    document.body.appendChild(link)
    link.click()
    link.remove()
    window.URL.revokeObjectURL(url)
  }
}

// 转换url
const transform = function transform (url, params) {
  if (typeof params === 'object') {
    let p = JSON.parse(JSON.stringify(params))
    for (let key in p) {
      let index = url.indexOf(`{${key}}`)
      if (index > -1) {
        url = url.replace(`{${key}}`, p[key])
        delete p[key]
      }
    }
    return { url }
  }
  return { url, params }
}

const setRemRatio = function () {
  var tid
  var docEl = document.documentElement
  var refreshRem = function () {
    var clientWidth = docEl.clientWidth < 750 ? docEl.clientWidth : 750
    var rem = clientWidth / 750
    docEl.style.fontSize = (rem * 100) + 'px'
  }
  window.addEventListener('resize', function () {
    clearTimeout(tid)
    tid = setTimeout(refreshRem, 300)
  }, false)
  refreshRem()
}

// md5加密
const md5Encrypt = function (key) {
  let str = `jty@*+.${key}.$#encodeducom`
  let md5Key = md5(str)
  return md5Key
}
// 手机号中间4位*代替
const getEncryPhone = function (phone) {
  if (phone) {
    return phone.substring(0, 3) + '****' + phone.substring(7)
  }
}

// 加法
const accAdd = function (arg1, arg2) {
  let r1, r2, m
  if (parseInt(arg1) === arg1) {
    r1 = 0
  } else {
    r1 = arg1.toString().split('.')[1].length
  }
  if (parseInt(arg2) === arg2) {
    r2 = 0
  } else {
    r2 = arg2.toString().split('.')[1].length
  }
  m = Math.pow(10, Math.max(r1, r2))
  return (arg1 * m + arg2 * m) / m
}

// 乘法
const accMul = function (arg1, arg2) {
  let m = 0
  let s1 = arg1.toString()
  let s2 = arg2.toString()
  try {
    m += s1.split('.')[1].length
  } catch (e) {
  }
  try {
    m += s2.split('.')[1].length
  } catch (e) {
  }
  return Number(s1.replace('.', '')) * Number(s2.replace('.', '')) / Math.pow(10, m)
}

// 判断值是否为空(不包括对象)
const isEmpty = function (value) {
  if(value == "" || value == null || value == undefined){
    return true
  }
  if (typeof value === 'object' && value.constructor === Object) {
    return Object.keys(value).length === 0;
  }
  return false
}

// 去掉标点符号
const delDot = function(str) {
  return str;
  // return str.split(' ').filter(item => {
  //   return !/[\——|\（|\）|\ |\~|\`|\!|\@|\#|\$|\%|\^|\&|\*|\(|\)|\-|\_|\+|\=|\||\\|\[|\]|\{|\}|\;|\:|\"|\'|\,|\<|\.|\>|\/|\?/\，/\。/\；/\：/\“/\”/\》/\《/\|/\{/\}/\、/\!/\~/\`]/.test(item)
  // }).join(' ');
}

const splitWord = function(str, word, style = '') {
  if (!word) {
    return str;
  }
  let addName = word.split(' ').join('');
  let index = 0;
  if (str.indexOf(addName) > -1) {
    return str.replace(addName, '<em class="' + style + '">' + addName + '</em>');
  }
  let searchMap = [];
  for (const w of word.split(' ')) {
    if (!w || w === ' ' || w === '') {
      continue;
    }
    if (searchMap.includes(w)) {
      continue;
    }
    searchMap.push(w);
    if (str.indexOf(w, index) >= index) {
      let temp = '<em class="' + style + '">' + w + '</em>';
      str = str.substr(0, index) + str.substr(index).replace(w, temp);
      index = index + temp.length;
    }

  }
  return str;
}

const hotSplit = function (tagText, searchkey) {
  let searchMap = [];
  let index = 0;
  for(const w of searchkey.split(' ')) {
    if (!w || w === ' ' || w === '' || ['^', '#', '$', '%', '!'].includes(w)) {
      continue;
    }
    if (searchMap.includes(w)) {
      continue;
    }
    searchMap.push(w);
    if (tagText.indexOf(w, index) >= index) {
      let temp = '^!' + w + '!$';
      tagText = tagText.substr(0, index) + tagText.substr(index).replace(w, temp);
      index = index + temp.length;
    }
  }
  return tagText;
}

const hotWord= function(str, searchkey) {
  if (!searchkey || !str) {
    return str;
  }
  let mathArr = str.match(/<math.*?>[^]*?<\/math>/g)
  let latexArr = str.match(/\\\(.*?\\\)/g)
  let strLen = str.length;
  let regex = /<.*?>/g
  let matchArray;
  let start = 0; // 截取的初始位置
  let newStr = '';
  let matchLength;
  let tagStartPos;
  let tagEndPos;
  let tagText;
  if (mathArr) {
    str = str.replace(/<math.*?>[^]*?<\/math>/g, '%#%');
  }
  if (latexArr) {
    str = str.replace(/\\\(.*?\\\)/g, '%&%');
  }

  while((matchArray = regex.exec(str)) !== null) {
    let { 0: matchText, 1: leadingSlash, 2: tagName, 3: attributes, 4: closingSlash } = matchArray;
    // 本次匹配到的字符串
    matchLength = matchText.length;
    // 本次匹配的起始位置
    tagStartPos = regex.lastIndex - matchLength;
    // 本次匹配的末尾位置
    tagEndPos = regex.lastIndex
    tagText = str.substring(start, tagStartPos);
    start = tagEndPos;
    tagText = hotSplit(tagText, searchkey);
    newStr += (tagText + matchText);
  }
  if (tagStartPos !== strLen) {
    tagText = str.substr(start, strLen);
    tagText = hotSplit(tagText, searchkey);
    newStr += tagText;
  }
  newStr = newStr.replace(/\^\!/g, '<del>');
  newStr = newStr.replace(/\!\$/g, '</del>');
  // 有math则替换回去
  if (mathArr) {
    let i = 0;
    newStr = newStr.replace(/%#%/g, (a) => {
      return mathArr[i++] || '';
    });
  }
  // 有latex则替换回去
  if (latexArr) {
    let i = 0;
    newStr = newStr.replace(/%&%/g, (a) => {
      return latexArr[i++] || '';
    });
  }
  return newStr;
}

const findNameInList = function(list, obj) {
  return _.find(list, obj) ? _.find(list, obj).name : "";
};

const findInList = function(list, obj, key) {
  return _.find(list, obj) ? _.find(list, obj) : {};
};

const appendScript = function(url, id = '') {
  var script = document.createElement("script");
  script.src = url;
  if (id && document.getElementById(id)) {
    return;
  }
  if (id) {
    script.id = id;
  }
  var s = document.getElementsByTagName("script")[0];
  s.parentNode.insertBefore(script, s);
}

const calPaperOption = (_option) => {
  let newoptions
  if (_option) {
    let newimgsrc = 'src="http://jty-xbzyk.obs.cn-north-4.myhuaweicloud.com/'
    let reg = new RegExp('src="/', 'g')
    newoptions = _option.replace(reg, newimgsrc)
    let editableReg = /contenteditable(="[^<>]*?")?/g;
    let blankReg = /<[^\/>]*?>(\s)*<\/.*?>/g;
    let blankPReg = /<p[^\/>]*?>(\s|&nbsp;)*<\/p>/g;
    let blankSpanReg = /<span style="width.*?display.*?inline-block.*?-aw-tabstop-align.*?-aw-tabstop-pos.*?">&nbsp;<\/span>/g;
    // 处理http的问题
		let http = new RegExp('http://', 'g')
    // 处理内联样式造成字体不一致问题
    let font = new RegExp('font-size', 'g')
    let family = new RegExp('font-family:[^<>]*?体;', 'g')
    let lineHeight = new RegExp('line-height', 'g')
    let color = new RegExp('color:', 'g')
    // 通过query去掉不闭合标签
    // let newStr = '';
    // let start = newoptions.indexOf('<');
    // 没有标签
    // if (start === -1) {
    //   newStr = newoptions;
    // }
    // 有标签
    // else {
    //   newStr = newoptions.substring(0, start);
    //   newoptions = newoptions.substring(start)
    //   for (let i = 0; i < $(newoptions).length; i++) {
    //     if ($(newoptions)[i].outerHTML) {
    //       newStr += $(newoptions)[i].outerHTML;
    //     }
    //   }
    // }

    // newoptions = newStr
    // 去除空标签
    // newoptions = newoptions.replace(blankReg, '')
    newoptions = newoptions.replace(editableReg, '')
    // newoptions = newoptions.replace(blankSpanReg, '')
    // newoptions = newoptions.replace(font, 'fontSize')
    // newoptions = newoptions.replace(family, '')
    newoptions = newoptions.replace(lineHeight, 'lineHeight')
    newoptions = newoptions.replace(color, 'colorFc:')
    newoptions = newoptions.replace(http, 'https://')
    // 先去掉标签里的多个空格
    newoptions = newoptions.replace(/<[^<>]*?>/g, (item) => {
      return item.replace(/\s+/g, ' ')
    })
    newoptions = newoptions.replace(/(vertical-align:\s?(super|sub))/g, '$1;font-size: 12px;')
    // newoptions = newoptions.replace(/(font-style:\s*?italic;)/g, '$1margin-right: 1px;')
  } else {
    newoptions = _option
  }
  return newoptions
}


const getByteLen = (str) => {
  let len = 0;
  for(let i = 0; i < str.length; i++) {
    str.charCodeAt(i) < 256 ? (len += 1) : (len += 2);
  }
  return len
}

const calPaperOptionWidth = (obj) => {
  let max = 0;
  for (let i in obj) {
    let newoptions = obj[i]
    let newStrLen = 0;
    // 拆掉标签算文字和图片的宽度
    // 先取出img标签
    let imgReg = /<img.*?>/ig;
    let imgContent = newoptions.match(imgReg);
    if (imgContent && imgContent.length > 0) {
      for (let i = 0; i < imgContent.length; i++) {
        if ($(imgContent[i])[0].width) {
          newStrLen += Math.ceil($(imgContent[i])[0].width / 7);
        }
      }
    }
    // 然后去掉所有标签
    let tagReg =  /(<([^>]+)>)/ig;
    newoptions = newoptions.replace(tagReg, '');
    newoptions = newoptions.replace(/\s*/g, '');
    newoptions = newoptions.replace(/&nbsp;/ig, '-');
    newStrLen += getByteLen(newoptions)

    max = newStrLen > max ? newStrLen : max
  }

  if (max > 30) {
    return 1;
  }
  else if (max > 10) {
    return 2;
  }
  else {
    return 4;
  }
}

const calFirstLine = () => {
  let questions = document.getElementsByClassName('question-options');
  for (let i = 0; i < questions.length; i++) {
    if (questions[i].className.indexOf('width1') === -1) {
      continue;
    }
    let options = questions[i].getElementsByTagName('li')
    for (let j = 0; j < options.length; j++) {
      let imgs = options[j].getElementsByTagName('img');
      let line = 32;
      for (let k = 0; k < imgs.length; k++) {
        line = imgs[k].clientHeight > line ? imgs[k].clientHeight : line
      }
      line = line + 15;
      if (options[j].offsetHeight > line) {
        document.getElementsByClassName('question-options')[i].getElementsByTagName('li')[j].className = 'firstLine';
      }
    }
  }
}

const calcTop = (dom, distance) => {
  distance = distance || 0
  if (!dom.offsetParent) {
    return dom.offsetTop
  }
  if (['BODY',null].includes(dom.offsetParent.nodeName)) {
      distance += dom.offsetTop
      return distance
  } else {
      distance += dom.offsetTop
      return calcTop(dom.offsetParent,distance)
  }
}

// 比较time1是否大于time2 或者当前时间是否比time1大
const compareTime = function (time1, time2) {
  if (typeof time1 === 'undefined') {
    return false;
  }
  if (typeof time2 === 'undefined') {
    return new Date().getTime() > new Date(time1).getTime();
  }
  return new Date(time1).getTime() > new Date(time2).getTime()
}

const dateFormat = function (date, format = 'YYYY-MM-DD') {
  if(date === undefined) {
    return ''
  }
  return moment(date).format(format)
}

const isUndefined = (data) => {
  if (!data) {
    return true;
  }
  if (Object.prototype.toString.call(data) === '[object Array]' && data.length === 0) {
    return true
  }
  if (Object.prototype.toString.call(data) === '[object object]' && JSON.stringify(obj) === '{}') {
    return true
  }
  return false;
}

const creatRandomName = (id, arr) => {
  let map =  ['政在学习', '地理king李', '秋水仙素', '茉莉花', '清风明月', '心之旅人', '风之彼岸', '故乡的云1', '地球人wghdy', '酒石酸', '七月时光', '志存高远', '幸福的微笑', '真心流露', '飞鱼888', '春江水暖', '苏氨酸', '奶油桃子', '知书达理', '温暖阳光', '心灵魔法师', '闲云野鹤w', '五音不全', '百里酚蓝', '雪落纷纷', '博闻强记', '逐梦远方', '旅行的意义', '别鹤h296', '莫尔盐', 'joy123', '心如止水', '笑谈人生', '琉璃画卷', '直角边', '惯兰高手', '喜树碱', '同煮山川', '云淡风轻', '青杉依旧', '笑谈人生', '开心超人', '几度枫红', '硅格离子', '琉璃月', '高山流水', 'GGBond', '庐州月', '海上月光', '如沐春风', '墨点', '心如止水', '爱上物理课', '我爱学习', '花椰菜', '夏天的西瓜', '贝多芬', '摸鱼的猫', '大理的夜', '叶十七', '笔墨纸砚', '柒小点', '流星飞舞', '罗刹市', '春天秋水', '萍水相逢', 'wangbin', '墨菲定律233', '颖星月', '印幻肖邦jhy1', '心灵之约', '清风徐来', '天涯过客', 'aasscc', '倚天飞梦', '上善若水99', '梦幻彩虹', '懒惰的兔子', '长安的荔枝', '怪侠一枝花', '雪山飞狐', 'Serendipity', '青花瓷', '小资源源', '笑语如歌', '一花一世界', '红尘客栈', '小图源解', '春风拂面', '星辰大海', '裹着心的光', '墨袖铜香', 'lixxc', '沉默是金', '文房墨宝', 'jhgui', '海阔天空'];
  if (arr) {
    map = arr;
  }
  let len = map.length;
  let index = +id % len;
  return map[index] || '九科星研究院'
}

const composedPath = (e) => {
  // 存在则直接return
  if (e.path) { return e.path }
  // 不存在则遍历target节点
  let target = e.target
  e.path = []
  while (target.parentNode !== null) {
    e.path.push(target)
    target = target.parentNode
  }
  // 最后补上document和window
  e.path.push(document, window)
  return e.path
}

const searchClass = (oriClass, arr) => {
  let res = false;
  for(let i = 0; i < arr.length; i++) {
    if(arr[i].className && arr[i].className.includes(oriClass)) {
      res = true;
      break;
    }
  }
  return res;
}

// 将一个二维数组中满足某个条件的对象元素排在数组的前面
const promoteObjects = (arr, conditionKey, conditionValue) => {
  // 创建一个新的空数组，用于存放满足条件的对象
  let promoted = [];

  if (!conditionValue) {
    return [...arr]
  }

  if (conditionKey) {
    // 遍历原始数组
    for (let i = arr.length - 1; i >= 0; i--) {
      // 如果数组的当前元素是一个对象，并且对象的条件键为数组，数组里面的nade等于条件值
      if (arr[i] && arr[i][conditionKey] && arr[i][conditionKey].length > 0) {
        let conditionKeyArr = arr[i][conditionKey].map(item => item.id);
        if (conditionKeyArr.includes(conditionValue)) {
          // 把这个对象添加到满足条件的数组里
          promoted.unshift(arr[i]);
          arr.splice(i, 1)
        }
      }
    }
  }
  else {
    for (let i = arr.length - 1; i >= 0; i--) {
      // 如果数组的当前元素是一个对象，并且对象的条件键为数组，数组里面的nade等于条件值
      if (arr[i] && arr[i].id) {
        if (arr[i].id === conditionValue) {
          // 把这个对象添加到满足条件的数组里
          promoted.unshift(arr[i]);
          arr.splice(i, 1)
        }
      }
    }
  }

  // 把满足条件的对象数组和原始数组的其他元素合并
  return [...promoted, ...arr];
}

// 合并两个二维数组并去重
const mergeAndRemoveDuplicates = (array1, array2) => {
  // 合并两个数组
  let mergedArray = [...array1, ...array2];

  // 使用reduce方法去重
  let uniqueArray = mergedArray.reduce((accumulator, currentItem) => {
    // 检查当前元素是否已经存在于累加器中
    if (!accumulator.some(item => JSON.stringify(item) === JSON.stringify(currentItem))) {
      // 如果不存在，则将当前元素添加到累加器中
      accumulator.push(currentItem);
    }
    return accumulator;
  }, []);

  return uniqueArray;
}

// 四舍五入到指定的小数位数
const roundToDecimalPlace = (number, decimalPlaces) => {
  const factor = Math.pow(10, decimalPlaces);
  return Math.round(number * factor) / factor;
}


const formatNumber = (num) => {
  if (!num) {
    return 0;
  }
  if (num >= 1000 && num < 10000) {
    return (num / 1000).toFixed(1) + 'k';
  } else if (num >= 10000) {
    return (num / 10000).toFixed(1) + 'w';
  } else {
    return num.toString();
  }
}

const distribute = (n, ratios) => {
  const totalRatio = ratios.reduce((a, b) => a + b, 0);

  // Step 1: Initial distribution based on ratios
  let initialDistribution = ratios.map(ratio => Math.round(ratio / totalRatio * n));

  // Step 2: Adjust to ensure the sum equals n
  let totalDistributed = initialDistribution.reduce((a, b) => a + b, 0);

  while (totalDistributed < n) {
    for (let i = 0; i < initialDistribution.length; i++) {
      if (totalDistributed < n) {
        initialDistribution[i]++;
        totalDistributed++;
      }
    }
  }

  while (totalDistributed > n) {
    for (let i = 0; i < initialDistribution.length; i++) {
      if (totalDistributed > n && initialDistribution[i] > 0) {
        initialDistribution[i]--;
        totalDistributed--;
      }
    }
  }

  return initialDistribution;
}

const getRandomInt = (max) => {
  return Math.floor(Math.random() * max);
}

// 随机排列数组
function shuffleArray(array) {
  // 创建一个新数组来保存结果
  const shuffledArray = array.slice();

  for (let i = shuffledArray.length - 1; i > 0; i--) {
    // 生成随机索引
    const j = Math.floor(Math.random() * (i + 1));

    // 交换元素
    [shuffledArray[i], shuffledArray[j]] = [shuffledArray[j], shuffledArray[i]];
  }

  return shuffledArray;
}

const splitArrayRandomly = (arr, m) => {
  // 先随机排列下数组
  arr = shuffleArray(arr)
  const n = arr.length;
  const result = Array.from({ length: m }, () => []);

  if (n < m) {
    // If n < m, each new array will have exactly one element, rest will be empty
    for (let i = 0; i < n; i++) {
      result[i].push(arr[i]);
    }
  } else {
    // If n >= m, distribute elements as evenly as possible
    const baseSize = Math.floor(n / m);
    let remainder = n % m;

    // Create a copy of the array to manipulate
    let tempArray = [...arr];

    for (let i = 0; i < m; i++) {
      let currentSize = baseSize + (remainder > 0 ? 1 : 0);
      remainder--;

      for (let j = 0; j < currentSize; j++) {
        // Randomly select an index from the tempArray
        let randomIndex = getRandomInt(tempArray.length);
        // Remove the element from tempArray and add it to the current result array
        result[i].push(tempArray.splice(randomIndex, 1)[0]);
      }
    }
  }

  return result;
}

const arrayProductSum = (arr1, arr2) => {
  let min = Math.min(...[arr1.length, arr2.length])
  if (min === 0) {
    return 0;
  }
  let sum = 0;
  let num = 0;
  for (let i = 0; i < min; i++) {
    sum += (+arr1[i] * +arr2[i])
    num += +arr1[i]
  }
  return (sum / num).toFixed(2)
}

const findNodeById = (node, id) => {
  // 检查当前节点的id是否匹配
  if (node.id === id) {
    return node;
  }

  // 如果有子节点，递归搜索每个子节点
  if (node.children) {
    for (let child of node.children) {
      let result = findNodeById(child, id);
      if (result) {
        return result;
      }
    }
  }

  // 如果没有找到，返回null
  return null;
}

const downloadByUrl = (url) => {
  let elemIF = document.createElement('iframe')
  let downloadUrl = url.replace('http:', '')
  elemIF.src = downloadUrl
  elemIF.style.display = 'none'
  document.body.appendChild(elemIF);
}

// 获取日期年月日格式
const getFormatterDate = (date) => {
  let dateTimes = new Date(date)
  let month = dateTimes.getMonth() < 9 ? '0' + (dateTimes.getMonth() + 1) : dateTimes.getMonth() + 1
  let day = dateTimes.getDate() <= 9 ? '0' + dateTimes.getDate() : dateTimes.getDate()
  let formattered = dateTimes.getFullYear() + '-' + month + '-' + day
  return formattered
}

const newGuid = () => {
  // eslint-disable-next-line
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
    /[xy]/g,
    function (n) {
      var l = (16 * Math.random()) | 0;
      return ("x" == n ? l : (3 & l) | 8).toString(16);
    }
  );
}

// img to mal
const mathmlToImg = function (str) {
  return str
    .replace(/[ΑΔΗΚΝΠΤΧαδηκνπσφωϖ′⁄ℜ←↓⇐⇓∂∇∋−∝∧∪∼≠≥⊄⊕⋅⌊♠♦¢¥®±´ΒΕΘΛΞΡΥΨβεθλξρτχϑ•″℘™↑↔⇑⇔∃∈∏∗∞∨∫≅≡⊂⊆⊗⌈⌋♣£¦©¬¯²µΓΖΙΜΟΣΦΩγζιμοςυψϒ…‾ℑℵ→↵⇒∀∅∉∑√∠∩∴≈≤⊃⊇⊥⌉◊♥¡¤§ª­°³⋯]/g, (c) => '&#' + c.charCodeAt(0) + ';')
    .replace(/</g, '«')
    .replace(/>/g, '»')
    .replace(/'/g, "`")
    .replace(/"/g, '¨')
    .replace(/\s+/g, ' ')
    .replace(/»\s+«/g, '»«')
    .replace(/&/g, '§')
}

// img to encode
const imgEncodeMathml = function (str) {
  return str.replace(/(<img[^<>]*?)class=\\"Wirisformula\\"(.*?)data-mathml=\\"([^<>]*?)\\"([^<>]*?>)/g, ($0, $1, $2, $3, $4) => {
    let mml = $3.replace(/&laquo;&nbsp;*?&raquo;/g, '&laquo;&raquo;')
      .replace(/&raquo;&nbsp;*?&laquo;/g, '&raquo;&laquo;')
      .replace(/(\/n)??&laquo;/g, '<')
      .replace(/&raquo;(\/n)??/g, '>')
      .replace(/&uml;/g, '"')
      .replace(/&die;/g, '"')
      .replace(/&sect;/g, '&')
      .replace(/&grave;/g, "'")
      .replace(/(\/n)??«/g, '<')
      .replace(/»(\/n)??/g, '>')
      .replace(/>(\/n)??</g, '><')
      .replace(/¨/g, '"')
      .replace(/§/g, '&')
      .replace(/`/g, "'")
    return ($1 + $2 + ' name=\\"' + Base64.encode(mml) + '\\"' + $4).replace(/data-latex/g, "nickName")
  })
}

export {
  downloadByUrl,
  findNodeById,
  deepClone,
  getFileType,
  downloadBlobFileByName,
  downloadFile,
  transform,
  setRemRatio,
  md5Encrypt,
  getEncryPhone,
  accAdd,
  accMul,
  isEmpty,
  checkOfficeType,
  delDot,
  splitWord,
  findInList,
  findNameInList,
  appendScript,
  calPaperOption,
  calPaperOptionWidth,
  hotWord,
  calFirstLine,
  calcTop,
  compareTime,
  dateFormat,
  isUndefined,
  creatRandomName,
  composedPath,
  searchClass,
  promoteObjects,
  mergeAndRemoveDuplicates,
  roundToDecimalPlace,
  formatNumber,
  distribute,
  splitArrayRandomly,
  arrayProductSum,
  getFormatterDate,
  newGuid,
  mathmlToImg,
  imgEncodeMathml
}



// WEBPACK FOOTER //
// ./src/utils/tools.js